import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { atHomeAllowedUpdateStatuses, atHomeUpdateStatusMap } from "@/constants";
import axios, { AxiosError } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

type AtHomeStatusUpdateRequestBody = {
  status: string;
  otp?: string;
};

const ALLOWED_AT_HOME_UPDATE_STATUSES = new Set<string>(atHomeAllowedUpdateStatuses);

export const useAtHomeBookingStatusUpdateAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (bookingId: string, status: string, otp?: string): Promise<boolean> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
        const mappedStatus = atHomeUpdateStatusMap[status] ?? status;
        if (!ALLOWED_AT_HOME_UPDATE_STATUSES.has(mappedStatus)) {
          toast.error("Invalid booking status for update.");
          return false;
        }

        const requestBody: AtHomeStatusUpdateRequestBody = {
          status: mappedStatus,
          ...(otp ? { otp } : {}),
        };

        const response = await axios.put(
          `${PATIENT_WAITING_LIST?.AT_HOME_STATUS_ACTION?.baseURL}${bookingId}/`,
          requestBody,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (response?.data?.status === true) {
          toast.success("Booking updated successfully");
          return true;
        }
        // toast.error(response?.data?.message || "Booking update failed");
        return false;
      } catch (error) {
        // const axiosError = error as AxiosError;
        // sendCurl((axiosError.config as any)?.curlCommand);
        // captureError(axiosError);
        toast.error("Booking update failed");
        return false;
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, sendCurl],
  );

  return { execute };
};
